import { Component } from '@angular/core';

@Component({
  selector: 'shared-core-expandable-card-header',
  imports: [],
  template: ` <ng-content /> `,
})
export class ExpandableCardHeaderComponent {}
